import { useState, useEffect, useRef } from "react";
import { createObserver, hasObserver } from "./lib/createObserver";

/**
 * LazyLoad Component
 *
 * References:
 * https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
 * https://developers.google.com/web/fundamentals/performance/lazy-loading-guidance/images-and-video/
 *
 * Usage Example:
 *
 * <LazyLoad>
 *    <img src=" *foo" />
 * </LazyLoad>
 */
const LazyLoad = (props) => {
    const [display, setDisplay] = useState(false);
    const refElement = useRef();
    let release = () => {};

    useEffect(() => {
        release();

        if (!refElement.current || display) {
            return;
        }

        if (!hasObserver()) {
            setDisplay(true);
        } else {
            release = createObserver(refElement.current, () =>
                setDisplay(true)
            );
        }

        return () => {
            release();
        };
    }, []);

    if (display) {
        return props.children ? props.children : null;
    }

    return (
        <div ref={refElement} className="lazy-load" data-testid="lazy-load" />
    );
};

export default LazyLoad;
